import { nftsAbstracts } from "contains/fakeData";


import HIW1 from "images/hWork/reunion.webp";
import HIW2 from "images/hWork/eleccion.webp";
import HIW3 from "images/hWork/discusion.webp";
import HIW4 from "images/hWork/subir.webp";
import customWeb from "images/services/customizacionweb.webp";
import customHosting from "images/services/hosting.webp";
import customSsl from "images/services/ssl.webp";
import customMantencion from "images/services/mantencionweb.webp";
import customresponsive from "images/services/responsive.webp";
import customseo from "images/services/seo.webp";

import photoPerfil from "images/about/me.webp";
import photoPerfil2 from "images/about/nicolas.jpg";

export interface PricingItem {
  isPopular: boolean;
  name: string;
  pricing: string;
  pricing2: string;
  desc: string;
  per: string;
  features: string[];
  offer?: {
    discount: string;
    pricing: string;
  };
}

export const CustomersData = [
  {
    id:1,
    name:'Santiago PaperChase',
    href:'https://santiagopaperchase.netlify.app/',
    image:'https://res.cloudinary.com/drju7lpxl/image/upload/v1712854141/BecauseYes/Customers/zan2v61ocqwhbcrmx6qs.png',
    showHome: true
  },
  {
    id:2,
    name:'CYVM',
    href:'https://cyvm.cl/',
    image:'https://res.cloudinary.com/drju7lpxl/image/upload/v1712854140/BecauseYes/Customers/sfkc34rdp0hn7pnfk8um.png',
    showHome: true
  },
  {
    id:3,
    name:'Carpas MRozas',
    href:'https://carpaseventosmrozas.com/',
    image:'https://res.cloudinary.com/drju7lpxl/image/upload/v1712854142/BecauseYes/Customers/nhecqwuhtb2luxxfe4bg.png',
    showHome: true
  },
  {
    id:4,
    name:'Veterinaria Móvil Pet',
    href:'https://movilpet.cl/',
    image:'https://firebasestorage.googleapis.com/v0/b/vmmpet-db.appspot.com/o/vmmpet%2Fmovilpet-screen.png?alt=media&token=6044e078-b707-4feb-98cd-b4863e5361fa',
    showHome: true
  },
  {
    id:5,
    name:'Unne',
    href:'https://unne.cl/',
    image:'https://firebasestorage.googleapis.com/v0/b/vmmpet-db.appspot.com/o/customers%2FunneScreen.png?alt=media&token=4013e082-d49f-4401-8f0d-9bb01d762a3f',
    showHome: true
  },
  {
    id:6,
    name:'Constructora Vasben',
    href:'https://constructoravasben.cl/',
    image:'https://firebasestorage.googleapis.com/v0/b/constructoravasben-bd-6942f.firebasestorage.app/o/FondoWeb%2FfondoVasben.png?alt=media&token=76670820-114b-4970-a17f-45f7a1c66679',
    showHome: true
  },
  {
    id:7,
    name:'Calexpro',
    href:'https://calexpro.cl/',
    image:'https://res.cloudinary.com/drju7lpxl/image/upload/v1739387879/calexpro/Captura_de_pantalla_2025-02-04_174841_e60ooy.png',
    showHome: true
  },
  {
    id:8,
    name:'Alannothing',
    href:'https://alan-nothing.com/',
    image:'https://res.cloudinary.com/drju7lpxl/image/upload/v1744075705/Alannothing/Portada/portadaAlannothingIngle_vni80u.png',
    showHome: true
  },
]

export const servicesData = [
  {
    featured:true,
    img:customWeb,
    title:"Web customization",
    descrip:"process of adjusting and customizing the design, appearance, and functionality of a website according to specific needs and preferences."
  }, 
  {
    featured:false,
    img:customMantencion,
    title:"Maintenance.",
    descrip:"continuous process of updating, error correction, optimization and resource management to ensure the performance and relevance of a web page."
  },    
  {
    featured:false,
    img:customHosting,
    title:"Hosting",
    descrip:"Hosting for your website, allowing your site to be available to online visitors 24 hours a day."
  },    
  {
    featured:false,
    img:customSsl,
    title:"SSL Certificate",
    descrip:"It provides a secure connection, ensuring that transmitted data is protected from potential threats and ensuring the confidentiality of user information."
  },    
  {
    featured:false,
    img:customresponsive,
    title:"Adaptive Design",
    descrip:"Ability of a website to adapt and provide an optimal experience on various devices and screen sizes."
  },    
  {
    featured:false,
    img:customseo,
    title:"Web Positioning (SEO)",
    descrip:"Set of strategies and techniques to improve the visibility of a website in search results."
  }
];

export const HowItWork_Data = [
  {
    id: 1,
    img: HIW1,
    imgDark: HIW1,
    title: "Contact us",
    desc: "Contact us to obtain the information you need.",
  },
  {
    id: 2,
    img: HIW2,
    imgDark: HIW2,
    title: "Customize",
    desc: "You can customize colors, design and images you want.",
  },
  {
    id: 3,
    img: HIW3,
    imgDark: HIW3,
    title: "Approval",
    desc: "After some time, we will send you your completed web template for a final review.",
  },
  {
    id: 4,
    img: HIW4,
    imgDark: HIW4,
    title: "Generate views",
    desc: "Finally, if the design meets your expectations, we can activate it on the website in a matter of hours..",
  },
];

export const pricingsServices: PricingItem[] = [
  {
    isPopular: true,
    name: "Standard",
    pricing: "€324",
    pricing2: "€14",
    per: "/first pay",
    features: [
      "Landing",
      "Adaptive Design",
      "Domain",
      "Hosting",
      "SSL Certificate",
      "Custom Emails"
    ],
    desc: `By selecting, you are accepting the terms and conditions.`,
    offer:{
      /* discount:'20%',
      pricing:'$71.990' */
      discount:'',
      pricing:''
    }
  },
  {
    isPopular: false,
    name: "Premium",
    pricing: "€690",
    pricing2: "€16",
    per: "/first pay",
    features: [
      "Website",
      "Adaptive Design",
      "Domain",
      "Hosting",
      "SSL Certificate",
      "Web Positioning (SEO)",
      "Custom Emails"
    ],
    desc: `By selecting, you are accepting the terms and conditions.`,

    offer:{
      discount:'10%',
      pricing:'€621'
    }
  },
];


export const AboutData = {
  main: {
    title:'👋 About Us',
    description: 'Welcome to our team of highly qualified programmers dedicated to bringing your ideas to digital life. We are a passionate group of professionals who combine advanced technical knowledge with unlimited creativity..'
  },
  // Statistic:{
  //   title:'🚀 Datos Impactantes',
  //   description:'Somos imparciales e independientes, y cada día creamos páginas y contenido distintivo.',
  //   FOUNDER_DEMO: [
  //     {
  //       id: "1",
  //       heading: "10 millones",
  //       subHeading:
  //         "Diseños webs han sido publicados en todo el mundo",
  //     },
  //     {
  //       id: "2",
  //       heading: "100,000",
  //       subHeading: "Cuentas de usuarios registrados",
  //     },
  //     {
  //       id: "3",
  //       heading: "220+",
  //       subHeading:
  //         "Clientes cuentan con nuestra presencia",
  //     },
  //   ]
  // },
  founders:{
    title:'Founders',
    description:'Each member of our team is a computer scientist with a solid academic background and 2 or more years of experience in web development.',
    profile:[
      {
        id: "1",
        name: `Fabian Angelo Astete Salas`,
        job: "Co-founder, CEO and web developer",
        avatar:photoPerfil,
        hrefInst:'',
        hrefGit:'https://github.com/sawiwi',
        hrefLink:'https://www.linkedin.com/in/fabian-astete-salas-820a45190/',
      },
      {
        id: "2",
        name: `Nicolás Cabrera Millacan`,
        job: "Co-founder, direct executive y computer engineer",
        avatar:photoPerfil2,
        hrefInst:'',
        hrefGit:'https://github.com/jaackx1',
        hrefLink:'https://www.linkedin.com/in/nicolas-cabrera-m',
      },

    ]
  }
}